module.exports = "\n<table class=\"ui items\" style=\"width:100%\">\n  \n  <tr>\n    <td style=\"width:15%\" >{{platz.LS_ZoneEin}}</td>\n    <td style=\"width:35%\" >{{platz.LS_Lagerplatztext}}</td> \n    <td style=\"width:15%; text-align:right\" >{{platz.LSI_LHAnzahl}} {{platz.LSI_LHTyp}} </td>\n    <td style=\"width:20%; text-align:right\" >{{platz.LSI_Menge}} {{platz.AT_LagerME}}</td>\n    <td style=\"width:15%\" >{{platz.LSI_MHDDatum}}</td>\n  </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// D:/Crossplatform/swsLagerinfo/src/app/lagerplatzzeile/lagerplatzzeile.component.html
// module id = ../../../../../src/app/lagerplatzzeile/lagerplatzzeile.component.html
// module chunks = 1